<template>
  <table class="grid-big" :style="{ height: height }">
    <tr v-for="row in y" :key="row">
      <td v-for="col in x" :key="col" :style="{ width: 100 / x + '%' }" class="grid-big-td">
        <table class="grid-small">
          <tr>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  props: {
    x: {
      type: Number,
      default: 4
    },
    y: {
      type: Number,
      default: 5
    },
    height: {
      type: String,
      default: '100px'
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-big {
  border: 2px solid red;
  width: 100%;
  .grid-big-td {
    border: 1px solid red;
  }
}
.grid-small {
  width: 100%;
  height: 100%;
  td {
    border: 1px solid red;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Result/components/grid.vue